import React, { useCallback, useEffect, useState } from "react";

import { getAllEmails } from "services";

import { useCancelAsyncOnUnmount } from "utils";

import { AdminHead, AdminTable, Col, MainPage, Row } from "components";

export const Tracking = () => {
  const [emails, setEmails] = useState([]);
  const [loading, setLoading] = useState(true);
  const signal = useCancelAsyncOnUnmount()();

  const loadAllEmails = useCallback(() => {
    getAllEmails({
      signal,
    })
      .then((res) => {
        setEmails(res);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [signal]);

  useEffect(() => {
    loadAllEmails();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"admin"}>
      <AdminHead
        headline={`${emails ? emails.emailsSent : 0} emails sent`}
        description="All emails sent from the platform are automatically tracked. Here, they are grouped together by type. Only distinct clicks are counted, and unsubscribe clicks are excluded from click counts."
      />
      <Row>
        <Col>
          <AdminTable dataSource={emails ? emails.types : []} config={{}} />
        </Col>
      </Row>
    </MainPage>
  );
};
